class RoasterAutoplay extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.carousel = document.getElementById(this.getAttribute('carousel-id'));
    this.frame = this.carousel?.parentElement;
    this.button = this.querySelector('button');
    if (!this.carousel || !this.button) return;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.paused = this.motion.matches;
    this.hovered = false;
    this.focused = false;
    this.visible = false;
    this.cooldown = 0;
    const signal = this.controller.signal;
    this.button.addEventListener('click', () => {
      this.paused = !this.paused;
      this.updateLabel();
      this.schedule();
    }, { signal });
    this.frame.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
    }, { signal });
    this.frame.addEventListener('pointerleave', () => {
      this.hovered = false;
      this.schedule();
    }, { signal });
    this.frame.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
    this.frame.addEventListener('focusout', (event) => {
      this.focused = this.frame.contains(event.relatedTarget);
      this.schedule();
    }, { signal });
    const interacted = () => { this.cooldown = Date.now() + 8000; this.schedule(); };
    this.frame.addEventListener('pointerdown', interacted, { signal, passive: true });
    this.frame.addEventListener('wheel', interacted, { signal, passive: true });
    this.frame.addEventListener('keydown', interacted, { signal });
    document.addEventListener('visibilitychange', () => this.schedule(), { signal });
    this.motion.addEventListener('change', (event) => {
      if (event.matches) this.paused = true;
      this.updateLabel();
      this.schedule();
    }, { signal });
    this.observer = new IntersectionObserver(([entry]) => {
      this.visible = entry.isIntersecting && entry.intersectionRatio >= 0.3;
      this.schedule();
    }, { threshold: [0, 0.3] });
    this.observer.observe(this.carousel);
    this.updateLabel();
  }
  updateLabel() {
    this.button.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
    this.button.setAttribute('aria-pressed', String(this.paused));
  }
  schedule() {
    clearTimeout(this.timer);
    if (this.paused || this.hovered || this.focused || !this.visible || document.hidden) return;
    const delay = Math.max(4000, this.cooldown - Date.now());
    this.timer = setTimeout(() => {
      if (!this.isConnected) return;
      const max = this.carousel.scrollWidth - this.carousel.clientWidth;
      if (max > 2) {
        if (Math.abs(this.carousel.scrollLeft) >= max - 4) {
          this.carousel.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this.frame.querySelector('carousel-next-button button')?.click();
        }
      }
      this.schedule();
    }, delay);
  }
  disconnectedCallback() {
    clearTimeout(this.timer);
    this.observer?.disconnect();
    this.controller?.abort();
    this.controller = null;
  }
}
if (!customElements.get('roaster-autoplay')) customElements.define('roaster-autoplay', RoasterAutoplay);
